<template>
  <section class="desc-section">
    <LazyHydrate when-idle>
      <ProductTabs
        :product="product"
        :open-tab="activeTab"
        @changeTab="setActiveTab($event)"
      />
    </LazyHydrate>
  </section>
</template>

<script>
import ProductTabs from "./tabs/ProductTabs.vue";
import LazyHydrate from "vue-lazy-hydration";
import {
  TabsConfig,
  useProductTabs,
} from "~/modules/catalog/product/composables/useProductTabs";

export default {
  name: "ProductDescSection",
  props: {
    product: {
      default: null,
    },
  },
  components: {
    LazyHydrate,
    ProductTabs,
  },
  setup() {
    const { activeTab, setActiveTab } = useProductTabs();

    return {
      setActiveTab,
      activeTab,
      TabsConfig,
    };
  },
};
</script>
